import { noop } from '../utils/common';

export const useCustomEvent = () => {
  const publishDOM = (name: string, payload: number[]) => {
    const event = new CustomEvent(name, {
      detail: payload,
    });

    if (document?.body) {
      document.body.dispatchEvent(event);
    }
  };

  const subscribeDOM = (
    name: string,
    listener: (e: CustomEvent['detail']) => void,
  ) => {
    const internalListener = ((event: CustomEvent) => {
      listener(event.detail);
    });

    if (document?.body) {
      document.body.addEventListener(name, internalListener as EventListenerOrEventListenerObject);

      return () => {
        document.body.removeEventListener(name, internalListener as EventListenerOrEventListenerObject);
      };
    }

    return noop;
  };

  return {
    publishDOM,
    subscribeDOM,
  };
};
